module.exports = __webpack_public_path__ + "static/img/pic_27.be1a8f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_27.png
// module id = mK0O
// module chunks = 1